import React from "react";
import {
  BackupIcon,
  BrandingIcon,
  CheckmarkIcon,
  CloudHostingIconL,
  DashboardIcon,
  GlobeMapIcon,
  MultipleIspIcon,
  NextAiIcon,
  OfficeIcon,
  SettingsIcon,
  UdmIcon,
  UpdateIcon,
} from "@ubnt/icons";
import { IPrincipleSection } from "components/OverviewBrandPrinciples/OverviewBrandPrinciples.types";
import IndustryLeadingLottie from "./assets/lottie/industry-leading-full.mjs";
import SimpleSetupLottie from "./assets/lottie/simple-setup-full.mjs";
import ScalesWideTallLottie from "./assets/lottie/scales-wide-tall-full.mjs";
import SoftwareInnovationLottie from "./assets/lottie/software-innovation-full.mjs";

import IndustryLeadingMobileImg from "./assets/lottie/mobile/industry-leading.png";
import SimpleSetupMobileImg from "./assets/lottie/mobile/simple-setup.png";
import ScalesWideTallMobileImg from "./assets/lottie/mobile/scales-wide-tall.png";
import SoftwareInnovationMobileImg from "./assets/lottie/mobile/software-innovation.png";

export const BRAND_PRINCIPLES_CONFIG = [
  {
    id: "industry-leading-hardware",
    index: 0,
    title: "brandPrinciples.industryLeading.title",
    lottie: {
      file: IndustryLeadingLottie,
      loopSegments: [20, 140],
    },
    mobileBackground: IndustryLeadingMobileImg,
    playbackTimeInSeconds: 5,
    slides: [
      {
        id: "obsessive-attention",
        text: "landing.brandPrinciples.industryLeading.slide1",
        icon: <DashboardIcon size={40} />,
      },
      {
        id: "no-license-and-subscriptions",
        text: "landing.brandPrinciples.industryLeading.slide2",
        icon: <CheckmarkIcon size={40} />,
      },
      {
        id: "native-cloud-management",
        text: "landing.brandPrinciples.industryLeading.slide3",
        icon: <CloudHostingIconL size={40} />,
      },
    ],
  },
  {
    id: "simple-setup",
    index: 1,
    title: "brandPrinciples.simpleSetup.title",
    lottie: {
      file: SimpleSetupLottie,
      loopSegments: [40, 180],
    },
    mobileBackground: SimpleSetupMobileImg,
    playbackTimeInSeconds: 5,
    slides: [
      {
        id: "plug-and-play-deployment",
        text: "landing.brandPrinciples.simpleSetup.slide1",
        icon: <SettingsIcon size={40} />,
      },
      {
        id: "user-friendly-management-dashboards",
        text: "landing.brandPrinciples.simpleSetup.slide2",
        icon: <BrandingIcon size={40} />,
      },
      {
        id: "remote-monitoring",
        text: "landing.brandPrinciples.simpleSetup.slide3",
        icon: <MultipleIspIcon size={40} />,
      },
    ],
  },
  {
    id: "scales-wide-and-tall",
    index: 2,
    title: "brandPrinciples.scalesWideTall.title",
    lottie: {
      file: ScalesWideTallLottie,
      loopSegments: [40, 180],
    },
    mobileBackground: ScalesWideTallMobileImg,
    playbackTimeInSeconds: 5,
    slides: [
      {
        id: "tailored-for-everyone",
        text: "landing.brandPrinciples.scalesWideTall.slide1",
        icon: <OfficeIcon size={40} />,
      },
      {
        id: "scalable-for-any-size",
        text: "landing.brandPrinciples.scalesWideTall.slide2",
        icon: <BackupIcon size={40} />,
      },
      {
        id: "versatile-across-industries",
        text: "landing.brandPrinciples.scalesWideTall.slide3",
        icon: <GlobeMapIcon size={40} />,
      },
    ],
  },
  {
    id: "software-innovation",
    title: "brandPrinciples.softwareInnovation.title",
    lottie: {
      file: SoftwareInnovationLottie,
      loopSegments: [20, 140],
    },
    mobileBackground: SoftwareInnovationMobileImg,
    index: 3,
    playbackTimeInSeconds: 5,
    slides: [
      {
        id: "free-firmware-updates",
        text: "landing.brandPrinciples.softwareInnovation.slide1",
        icon: <UpdateIcon size={40} />,
      },
      {
        id: "continued-ai-optimization",
        text: "landing.brandPrinciples.softwareInnovation.slide2",
        icon: <NextAiIcon size={40} />,
      },
      {
        id: "performance-enhancements",
        text: "landing.brandPrinciples.softwareInnovation.slide3",
        icon: <UdmIcon size={40} />,
      },
    ],
  },
] satisfies Array<IPrincipleSection>;
